export class GoogleUser {
    name: string;
    email: string;
    photo: string;

    constructor(name: string, email: string, photo: string) {
        this.name = name;
        this.email = email;
        this.photo = photo;
    }
}